'use client';

import { CmsEditorialButton } from '@/cms/components/blocks/shared/cms-editorial-button';
import { CmsImage } from '@/cms/components/blocks/shared/cms-image';
import { CmsImageFrame } from '@/cms/components/blocks/shared/cms-image-frame';
import { CmsSectionShell } from '@/cms/components/blocks/shared/cms-section-shell';
import { CmsTitleGroup } from '@/cms/components/blocks/shared/cms-title-group';
import { renderAppIcon } from '@/components/icons/app-icon-registry';
import type { VideoMakerShowcaseRenderModel } from './types';

export function VideoMakerShowcaseBlockClient({
  model,
}: {
  model: VideoMakerShowcaseRenderModel;
}) {
  return (
    <CmsSectionShell
      width="default"
      spacing="default"
      className="cms-block-why-choose-us-why-choose-us-6-why-choose-us-6__section"
    >
      <CmsTitleGroup
        eyebrow={model.eyebrow}
        title={model.title}
        description={model.description}
        align="center"
        className="cms-block-why-choose-us-why-choose-us-6-why-choose-us-6__header"
      />

      <div className="cms-block-why-choose-us-why-choose-us-6-why-choose-us-6__featureStack">
        {model.items.map((item, itemIndex) => {
          const sectionId = `${model.blockId}-${item.key}`;
          const isAlternateCta = itemIndex % 2 === 1;

          return (
            <article
              key={`${model.blockId}-${item.key}`}
              id={sectionId}
              className="cms-block-why-choose-us-why-choose-us-6-why-choose-us-6__feature"
            >
              <div className="cms-block-why-choose-us-why-choose-us-6-why-choose-us-6__copyColumn">
                <h3 className="cms-title-card cms-block-why-choose-us-why-choose-us-6-why-choose-us-6__featureTitle">
                  {item.title}
                </h3>
                <p className="cms-body cms-block-why-choose-us-why-choose-us-6-why-choose-us-6__featureDescription">
                  {item.description}
                </p>

                <CmsEditorialButton
                  buttonKey="cta"
                  repeatedItem={{
                    collectionKey: 'items',
                    itemIndex,
                  }}
                  href={item.cta.href}
                  className={`cms-block-why-choose-us-why-choose-us-6-why-choose-us-6__cta ${
                    isAlternateCta
                      ? 'cms-block-why-choose-us-why-choose-us-6-why-choose-us-6__ctaAlternate'
                      : ''
                  }`}
                  variant="primary"
                >
                  <span>{item.cta.label}</span>
                  {renderAppIcon({
                    name: 'arrowright',
                    className:
                      'cms-block-why-choose-us-why-choose-us-6-why-choose-us-6__ctaIcon',
                  })}
                </CmsEditorialButton>
              </div>

              <div className="cms-block-why-choose-us-why-choose-us-6-why-choose-us-6__mediaColumn">
                <CmsImageFrame
                  ratio="landscape"
                  frameClassName="cms-block-why-choose-us-why-choose-us-6-why-choose-us-6__mediaFrame"
                >
                  {item.image ? (
                    <CmsImage
                      src={item.image.url}
                      alt={item.image.alt}
                      width={item.image.width}
                      height={item.image.height}
                      className="h-full w-full object-cover"
                    />
                  ) : (
                    <div
                      className="cms-block-why-choose-us-why-choose-us-6-why-choose-us-6__grayPlaceholder"
                      aria-hidden="true"
                    />
                  )}
                </CmsImageFrame>
              </div>
            </article>
          );
        })}
      </div>
    </CmsSectionShell>
  );
}
